<template>
  <!-- pro-item .pi -->
  <div>
    <div class="pi">
      <div class="pi-wrap" v-for="(item, index) in [1,1,1,1,1,1]" :key="'act-item-' + index">
        <div class="wrap" @click="$router.push(`/pro-details/${123123}`)">
          <div class="photo">
            <img
              src="https://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/201909/8c8cc0cbce31496dad157ba0ffb06219.jpg?x-oss-process=style/ex_pc_prolist"
              class="empty-img"
            />
          </div>
          <div class="title">
            <h3>一次性医用外科口罩手术医护口罩手术...</h3>
            <p style="padding-left: 12px;" class="title-line">
              <i class="icon iconfont icon-biaoqian1" style="color: #329bba;"></i>
              <span>手术器械01;02;03;04</span>
            </p>
          </div>
          <div class="company">
            <div class="logo">
              <img src="@assets/img/empty.png" class="empty-img" :class="{'s-circle': true}" />
            </div>
            <span>上海联展软件技术有限公</span>
          </div>
        </div>
      </div>
    </div>
    <div class="m-page">
      <Page
        show-total
        show-elevator
        :page-size="pageSize"
        :current="pageIndex"
        :total="totalCount"
        @on-change="changePage"
        @on-page-size-change="changePageSize"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "pro-item",
  data() {
    return {
      pageSize: 20,
      pageIndex: 1,
      totalCount: 120
    };
  },
  components: {},
  computed: {},
  methods: {
    init() {},
    changePage(e) {
      this.pageIndex = e;
      this.init();
      console.log("changePage: ", e);
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      console.log("changePageSize: ", e);
    }
  }
};
</script>

<style scoped lang="scss">
.m-page {
  padding-bottom: 50px;
  text-align: center;
}
.pi {
  margin-top: 20px;
  margin-bottom: 50px;
  overflow: hidden;
  &-wrap {
    cursor: pointer;
    display: block;
    width: 25%;
    float: left;
    background-color: #f5f5f5;
    overflow: hidden;
    padding-bottom: 10px;
    padding-right: 20px;
    color: #ccc;
    &:nth-of-type(4n) {
      padding-right: 0px;
    }
  }
}
</style>
<style scoped lang='scss'>
@import "@assets/scss/utils.scss";
.wrap {
  width: 100%;
  height: 316px;
  border-radius: 3px;
  background-color: #fff;
  position: relative;
  margin-bottom: 20px;
  float: left;
  cursor: pointer;
}
.wrap .photo {
  height: 190px;
  overflow: hidden;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  img {
    width: 100%;
    height: 100%;
  }
}
.wrap .title {
  height: 74px;
  border-bottom: 1px solid #f5f5f5;
  overflow: hidden;
}
.wrap .title h3 {
  font-size: 14px;
  padding: 0 14px;
  color: #333;
  line-height: 18px;
  margin-top: 16px;
  @include text-ellipsis();
}
.wrap .title {
  span {
    font-size: 14px;
    color: #999;
    line-height: 32px;
    padding-left: 4px;
  }
  .title-line {
    display: flex;
    align-items: center;
    span {
      width: calc(100% - 1px);
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.wrap .company {
  height: 50px;
  @include text-ellipsis();
}
.wrap .company .logo {
  display: inline-block;
  vertical-align: top;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: url(../../../../../assets/img/empty.png) no-repeat;
  background-size: 24px 24px;
  margin: 14px;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.wrap .company span {
  font-size: 14px;
  color: #666;
  line-height: 50px;
}
.wrap .icon2 {
  min-width: 68px;
  height: 24px;
  background-color: #1890ff;
  border-radius: 2px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  position: absolute;
  top: 172px;
  left: 14px;
  padding: 0 4px;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
